module.exports = __webpack_public_path__ + "static/media/ag.e45175f4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ag.svg
// module id = 2030
// module chunks = 0